<template>
  <div id="monitoring">
    <v-container fluid
                 grid-list-lg>
      <v-layout row
                wrap>
        <v-flex sm12
                lg6
                :key="wheel.id"
                v-for="wheel in wheels">
          <MonitoringRoundsTable :wheel="wheel"></MonitoringRoundsTable>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { config } from '@/api';
import MonitoringRoundsTable from '@/components/MonitoringRoundsTable';

export default {
  name: 'PageMonitoring',
  components: {
    MonitoringRoundsTable,
  },
  data() {
    return {
      wheels: [
        config.getConfig('sima').wheel,
        config.getConfig('isy').wheel,
        config.getConfig('plezi').wheel,
        config.getConfig('balkanbet').wheel,
        config.getConfig('pozeparyaj').wheel,
        config.getConfig('belparyaj').wheel,
        config.getConfig('livebet1x2').wheel,
        config.getConfig('luckyland').wheel,
        config.getConfig('bingobet').wheel,
        config.getConfig('modelparyaj').wheel,
      ],
    };
  },
};
</script>
